const HACCPThresholds = [{
    Minimum: 0,
    Maximum: 89.94,
    Color: "#b71402",
    Smiley: "frown-open"
}, {
    Minimum: 89.95,
    Maximum: 100,
    Color: "#36c259",
    Smiley: "grin"
}]

export default {
    methods: {
        // extracts the specified color value from the thresholds config object dependant of the specified value
        // values may string values like '65,34%' or Numbers like 43.12
        // if specified value or the config is not valid this method will return the specified default color
        getThresholdColor(thresholdConfig, value, defaultColor, sourceItem) {
            let retVal = defaultColor;

            if (thresholdConfig && value != undefined && value != null) {
                // normalize value
                const valueNormalized = isNaN(value) && (value.length > 0) ? Number(value.replace('%', '').replace(',', '.')) : value;

                if (sourceItem && (sourceItem.GroupCode === 'HACCP' || sourceItem.Code === 'HACCP'))
                    thresholdConfig = HACCPThresholds;

                // find corresponding threshold
                const threshold = thresholdConfig.find(thr => (thr.Minimum <= valueNormalized) && (valueNormalized <= thr.Maximum));
                if (threshold) {
                    retVal = threshold.Color;
                }
            }

            return retVal;
        }
    }
};